module.exports = __webpack_public_path__ + "static/media/movieTrackerImg.6159068e.png";